import React, { useEffect, useState } from 'react';
import { Card, Col, Modal, Row, Space, Spin, Typography } from 'antd';
import { useResponsive } from "../../utils/use-responsive";
import styles from "./connection-card-modal.module.scss";
import cardModalLogo from "../../assets/images/card-modal-logo.svg";
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useDocuments } from "../../context/documents.context";

const { Title, Text } = Typography;

export const ConnectionCardModal: React.FC<{
    title?: string;
    subtitle?: string;
    description?: any;
    show?: boolean;
    onClose?: () => void;
    onBack?: () => void;
    isBack?: boolean;
    isSmallTitle?: boolean;
    content?: any;
  }> = ( {
           title,
           subtitle,
           description = false,
           show = false,
           isSmallTitle = false,
           onClose,
           onBack,
           isBack,
           content = false
         } ) => {
    const { isTablet, isMobile } = useResponsive();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { documentLoading } = useDocuments();

    const showModal = (state:boolean) => {
      setIsModalOpen(state)
    };

    useEffect(() => {
      showModal(show)
    }, [show]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleOk = () => {
      console.log("Clicked OK");
    };

    return (
      <Modal
        open={isModalOpen}
        onOk={handleOk}
        onCancel={onClose}
        okText="Confirm"
        footer=""
        className={styles['dashboardModal']}
        style={{ marginTop: isMobile ? "-34px" : "0" }}
      >
        <Spin
          size={'large'}
          tip="Loading..."
          className={'full-width'}
          spinning={documentLoading}>

          <Card bordered={!isMobile}
                cover={
                  <Row justify="space-between"
                       style={{
                         flexDirection: isMobile ? 'column' : 'row'
                       }}
                  >
                    <Col className={styles['dashboardModalLeft']}
                         style={{
                           backgroundImage: isMobile ? 'none' : `url(${cardModalLogo})`,
                           backgroundColor: isMobile ? '#ffffff' : '#212121',
                           width: isMobile ? 'auto' : 'inherit',
                           padding: isMobile ? '30px' : '90px 30px 300px 30px',
                           justifyContent: isMobile ? 'center' : 'left',
                           textAlign: 'left'
                         }}
                    >
                      <Space direction="vertical" size="middle">
                        <Space direction="horizontal" size="middle">
                          {isBack &&
                              <ArrowLeftOutlined onClick={onBack} style={{ color: isMobile ? '#000000' : '#ffffff' }}/>
                          }
                          {isSmallTitle ?
                            <Title style={{
                              fontSize: isMobile ? '1.2rem' : '1.4rem',
                              color: isMobile ? '#000000' : '#ffffff',
                              lineHeight: '32px',
                              fontWeight: '500'
                            }}>{title}</Title>
                            :
                            <Title style={{
                              fontSize: isMobile ? '1.5rem' : '2.2rem',
                              color: isMobile ? '#000000' : '#ffffff',
                              lineHeight: '45px',
                              fontWeight: '500'
                            }}>{title}</Title>
                          }

                        </Space>
                        {subtitle &&
                            <Title style={{
                              fontSize: isMobile ? '0.9rem' : '1rem',
                              color: isMobile ? '#000000' : '#DDDDDD',
                              fontWeight: '400',
                              lineHeight: '28px'
                            }}>{subtitle}</Title>
                        }
                        {!isMobile && <Text style={{
                          fontSize: isTablet ? '0.7rem' : '0.9rem',
                          color: isMobile ? '#000000' : '#DDDDDD',
                          lineHeight: '22px'
                        }}>{description}</Text>
                        }
                      </Space>
                    </Col>
                    <Col
                      className={styles['dashboardModalRight']}
                      style={{
                        flex: isMobile ? '1' : '2',
                        padding: isMobile ? '0 30px 30px 30px' : '50px 95px'
                      }}>
                      <Space direction={'vertical'} size={'large'} className={'full-width'} style={{height:"100%"}}>
                        {content}
                        {isMobile && <Text style={{
                          fontSize: isTablet ? '0.7rem' : '0.9rem',
                          color: isMobile ? '#000000' : '#DDDDDD',
                          lineHeight: '22px'
                        }}>{description}</Text>
                        }
                      </Space>
                    </Col>


                  </Row>
                }
          >
          </Card>
        </Spin>
      </Modal>
    )
      ;
  }
;
